module.exports = __webpack_public_path__ + "static/img/3.b93dbeea.png";